import { connect } from 'react-redux';
import { AboutUs } from '../../components';

export default connect(null)(AboutUs);